<template>

	<div class="user_wbox">
		<div class="inter">
			<div class="div1 t-flex">
				<div class="fl">
					<div class="user_ti">个人中心</div>
					<div class="user_menu">
						<div class="item" @click="open(item)" :class="{'active':menu_id == item.id}"
							v-for="(item, index) in menu">
							{{item.name}}
						</div>

					</div>
				</div>
				<div class="fr">

					<div class="user_center">

						<div class="user_de_ti" style="margin-bottom: 30px;">我的订单</div>



						<div class="order_fr_menu t-flex t-flex-items-center">
							<div class="item" @click="orderChange(item)" :class="{'active':activeName == item.value}"
								v-for="(item, index) in order_menu">
								<span>{{item.name}}</span>
							</div>

						</div>


						<div class="user_page_list">


							<div class="newOrder">

								<div class="newOrder_list" @click="openOrder(item)" v-for="(item, index) in list">
									<div class="newOrder_top">
										<div class="newOrder_top_left"><span>订单编号：{{item.order_no}}</span>

										</div>
										<div class="newOrder_top_right CANCEL" v-if="item.status == '2'">已取消</div>
										<div class="newOrder_top_right BUYER_AGREE" v-if="item.status == '0'">待付款</div>
										<div class="newOrder_top_right AGREE" v-if="item.status == '1'">待取号</div>
										<div class="newOrder_top_right AGREE" v-if="item.status == '3'">已完成</div>

									</div>

									<div class="newOrder_content">
										<div class="el-image newOrder_content_img"><img :src="item.cmsarchives.image"
												class="el-image__inner"></div>
										<div class="newOrder_content_info newOrder_width76">
											<h4 class="newOrder_content_title ellipsis-3">
												{{item.cmsarchives.title}}
											</h4>
											<p class="newOrder_content_bottom">创建时间：{{item.createtime}}
											</p>
										</div>
										<div class="newOrder_content_mony">
											￥{{item.price}}
										</div>
									</div>
								</div>
							</div>




							<div class="page_fenye" v-if="pagination.total > 0">
								<el-pagination background layout="prev, pager, next" :total="pagination.total"
									:page-size="pagination.per_page" @current-change="handleCurrentChange">
								</el-pagination>
							</div>
						</div>

					</div>



				</div>
			</div>
		</div>
	</div>

</template>


<script>
	import {
		Notification,
		Message
	} from 'element-ui'
	import moment from 'moment';
	export default {
		data() {
			return {
				list: [],
				content: "",
				active: 2,
				title: "",
				info: {},
				acc: "",
				pass: "",
				pass2: "",
				code: "",
				menu_id: 6,
				menu: [{
						id: 1,
						name: "主页",
						url: "/user"
					},
					{
						id: 2,
						name: "我的收藏",
						url: "/shoucang"
					},
					// {
					// 	id: 3,
					// 	name: "我发布的账号",
					// },
					{
						id: 6,
						name: "我的订单",
						url: "/order"
					},
					{
						id: 4,
						name: "修改密码",
						url: "/editpass"
					},
					{
						id: 5,
						name: "注销",
					}
				],
				page: 1,
				list: [],
				pagination: {
					total: 0,
					per_page: 0,
				},
				activeName: -1,

				order_menu: [{
						name: "全部",
						value: -1
					},
					{
						name: "待付款",
						value: 0
					},
					{
						name: "待取号",
						value: 1
					},
					{
						name: "已完成",
						value: 3
					},
					{
						name: "已取消",
						value: 2
					}
				]

			}
		},
		computed: {
			userinfo() {
				return this.$store.getters.userinfo
			}
		},
		created: function(data) {
			this.mylist()
			// this.getDetail();


		},
		watch: {
			$route() {

			}
		},
		methods: {
			formatTimestamp(timestamp) {
				return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
			},
			open(item) {
				if (item.id == 5) {
					localStorage.removeItem('usertoken')
					sessionStorage.removeItem('usertoken')
					localStorage.setItem('path', this.$route.path)
					this.$router.push("/")
				} else {

					this.$router.push(item.url)
				}
			},

			orderChange(item) {
				this.activeName = item.value
				this.page = 1
				this.mylist()
			},
			handleCurrentChange(val) {
				this.page = val
				this.mylist()
			},

			openOrder(item) {
				this.$router.push('/orderDetail?id=' + item.id)
			},


			mylist() {
				var that = this
				this.rq.requests.post("api/Order/mylist", {
					page: that.page,
					status: that.activeName
				}).then(res => {

					that.list = res.data.data
					that.pagination.total = res.data.total
					that.pagination.per_page = res.data.per_page
					that.page++

				}).catch(error => {

				})

			},






		}


	}
</script>